import { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

import { DateRange } from 'react-date-range'
import * as locales from 'react-date-range/dist/locale'

import './DateRangePickerStyles.css'
import { Typography } from '@material-ui/core'

export default function DateRangePicker({ ranges, ...props }) {
  const [collapsed, setCollapsed] = useState(props.collapsed || false)

  const toggleCollapse = (event) => {
    if (
      event.target.classList.contains('rdrDateDisplay') ||
      event.target.classList.contains('rdrDateDisplayWrapper')
    ) {
      setCollapsed((prev) => !prev)
    }
  }
  let handleSelect = (ranges) => {
    setCollapsed(true)
    props.handleSelect(ranges)
  }
  const useStyles = makeStyles(() => ({
    root: {
      '&.collapsed': {
        '& .rdrMonthAndYearWrapper, & .rdrMonths, & .rdrInfiniteMonths, & .rdrMonthsVertical, & .rdrWeekDays':
          {
            display: 'none',
          },
      },

      ...props.style,
    },
  }))
  const classes = useStyles(props)

  let selectionRange = ranges || {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }
  return (
    <>
      {props.label && (
        <Typography
          variant="subtitle1"
          color="primary"
          style={{ padding: '0' }}
        >
          {props.label}
        </Typography>
      )}
      <div {...props} onClick={props.open || toggleCollapse}>
        <DateRange
          {...props}
          className={clsx(classes.root, collapsed && 'collapsed')}
          moveRangeOnFirstSelection={true}
          ranges={[selectionRange]}
          editableDateInputs={true}
          onChange={handleSelect}
          showSelectionPreview={true}
          locale={locales['fr']}
          minDate={new Date('2020-01-01')}
          dateDisplayFormat="d MMM yyyy"
          startDatePlaceholder="Date début"
          endDatePlaceholder="Date fin"
        />
      </div>
    </>
  )
}
